import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물함")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "gift_box_cancle_detail_area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "detail_tit" }, "결제 취소 내역", -1)
const _hoisted_6 = { class: "detail_list_info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_information_component = _resolveComponent("information-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_information_component, { items: _ctx.paymentCancellationHistory }, null, 8, ["items"])
        ])
      ])
    ])
  ], 2))
}